module.exports = __webpack_public_path__ + "img/tour-42.5535cf63.png";